import React from 'react';

/**
 * Bunker brand logo component.
 *
 * `variant`:
 *   - 'light'   : default, white/cream wordmark on dark surface (matches PNG asset)
 *   - 'dark'    : black wordmark on light surface (uses CSS color override)
 *   - 'wordmark': pure CSS wordmark, no image (good for very small sizes / fallback)
 *
 * `size`:
 *   - in pixels for height; width auto. Aspect ratio of the PNG is roughly 1:1.
 */
export const Logo = ({
  variant = 'light',
  size = 28,
  showWordmarkOnly = false,
  className = '',
  withDot = false,
  ...rest
}) => {
  if (variant === 'wordmark' || showWordmarkOnly) {
    return (
      <span
        className={`bk-wordmark inline-flex items-baseline ${className}`}
        style={{ fontSize: size, lineHeight: 1, color: variant === 'dark' ? '#111' : undefined }}
        data-testid="bunker-logo-wordmark"
        {...rest}
      >
        <span style={{ opacity: 0.55, marginRight: 1 }}>.</span>bunker
      </span>
    );
  }

  // Image variant — use the cream-on-dark PNG for `light`, invert filter for `dark`
  return (
    <img
      src="/brand/bunker-logo.png"
      alt="Bunker"
      width={size * 1}
      height={size}
      style={{
        height: size,
        width: 'auto',
        objectFit: 'contain',
        ...(variant === 'dark' ? { filter: 'invert(1) brightness(0.92)' } : {}),
      }}
      className={`select-none ${className}`}
      data-testid="bunker-logo-img"
      {...rest}
    />
  );
};

export default Logo;
